export default "__VITE_ASSET__Dr2lfoL1__"